var cov_whhvdhlj7 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Icon/Icon.tsx",
      hash = "00aaebe542d0ace7129a5915f6a3f190226c02b8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Icon/Icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 85
        },
        end: {
          line: 16,
          column: 90
        }
      },
      "1": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 90
        }
      },
      "2": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "3": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "4": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "5": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "6": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "7": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 54,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "Icon",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 13
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 8,
            column: 25
          },
          end: {
            line: 14,
            column: 3
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }, {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Icon/Icon.tsx";
import React from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { iconClass } from './styles';

function Icon() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_whhvdhlj7.b[0][0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
    prefix: 'icon',
    fontFamily: 'iconfont',
    name: '',
    type: 'default'
  }));
  cov_whhvdhlj7.f[0]++;

  var _ref = (cov_whhvdhlj7.s[0]++, props),
      children = _ref.children,
      prefix = _ref.prefix,
      type = _ref.type,
      name = _ref.name,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      ext = _ref.ext,
      otherProps = _objectWithoutProperties(_ref, ["children", "prefix", "type", "name", "fontFamily", "fontSize", "ext"]);

  var className = (cov_whhvdhlj7.s[1]++, classnames(iconClass('_', type), props.className, "".concat(prefix, "-").concat(name)));
  var style = (cov_whhvdhlj7.s[2]++, Object.assign({}, {
    fontFamily: fontFamily,
    fontSize: fontSize
  }, props.style));
  cov_whhvdhlj7.s[3]++;

  if (ext === 'js') {
    cov_whhvdhlj7.b[1][0]++;
    cov_whhvdhlj7.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement("i", Object.assign({}, otherProps, {
        className: className,
        style: style,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 7
        }
      }),
      /*#__PURE__*/
      React.createElement("svg", {
        className: iconClass('svg'),
        "aria-hidden": "true",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32,
          columnNumber: 9
        }
      },
      /*#__PURE__*/
      React.createElement("use", {
        xlinkHref: "#".concat(prefix, "-").concat(name),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 11
        }
      })))
    );
  } else {
    cov_whhvdhlj7.b[1][1]++;
  }

  cov_whhvdhlj7.s[5]++;
  return (
    /*#__PURE__*/
    React.createElement("i", Object.assign({}, otherProps, {
      className: className,
      style: style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 5
      }
    }), children)
  );
}

cov_whhvdhlj7.s[6]++;
Icon.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  prefix: 'icon',
  fontFamily: 'iconfont',
  name: '',
  type: 'default'
});
cov_whhvdhlj7.s[7]++;
Icon.displayName = 'ShineoutIcon';
export default Icon;